<template>
  <div class="">
   <router-view></router-view>
  </div>
</template>

<script>

export default {
name: "App",

components: {},

methods: {},

mounted() {
  document.documentElement.style.setProperty('--backend-img-url', `url(${this.backendImgUrl}/body-bg.jpg)`), 
  document.documentElement.style.setProperty('--backend-img-size', 'cover'), 
  document.documentElement.style.setProperty('--backend-img-repeat', 'no-repeat'), 
  document.documentElement.style.setProperty('--backend-img-position', 'center center fixed');
},

};

</script>

<style>
  .section-padding--small {
    background-image: var(--backend-img-url);
    background-size: var(--backend-img-size);
    background-repeat: var(--backend-img-repeat);
    background-position: var(--backend-img-position);
}
.v-enter-active {
  /* transition: all 0.3s ease-out; */
  animation: slide-fade .8s ease-out;
}
.v-leave-active {
  /* transition: all 0.3s ease-in; */
  animation: slide-fade .8s ease-out;
}
.animate {
  /* transform: translateX(-100px); */
  animation: slide-fade 0.5s forwards;
}

@keyframes slide-fade {
  0% {
    /* transform: translateX(0) scale(1); */
    opacity: 0;
  }

  70% {
    /* transform: translateX(-120px) scale(1.1); */
    opacity: .5;
  }

  100% {
    /* transform: translateX(-150px) scale(1); */
    opacity: 1;
  }
}
</style>

